import React, {useEffect, useState} from "react";
import {injectIntl} from "react-intl";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import Misc from "../../../misc/misc";
import {changeUserInfo, changeUserInfoErrors} from "../../../actions/actionFunctions";
import {useIsMounted} from "../../../misc/helperHooks";
import UserFieldErrors from "../userPopup/userFieldsErrors";

const AssignQuotePopupNewCustomerInput = (props) => {

  const {property, userInfo, changeUserInfo, intl, placeholder, userInfoErrors, changeUserInfoErrors,
    inputsValidated, isActive, fabricatorData} = props;
  const [inputValue, setInputValue] = useState(userInfo[property] || "");
  const isMounted = useIsMounted();

  const onBlur = (event) => {
    const value = event.target.value.trim();
    changeUserInfo({
      [property]: value
    });
    const errors = Misc.getValidationErrors(value, property, fabricatorData);
    if (errors.length) {
      changeUserInfoErrors({
        [property]: errors
      })
    } else if (!errors.length && userInfoErrors[property]) {
      changeUserInfoErrors({
        [property]: errors
      })
    }
  };

  useEffect(() => {
    setInputValue(userInfo[property] || "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo[property]]);

  useEffect(() => {
    if (isMounted() && isActive) {
      // console.log("inputsValidated", inputsValidated);
      onBlur({
        target: {
          value: inputValue
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputsValidated]);

  const onChange = (event) => {
    setInputValue(event.target.value);
    if (userInfoErrors[property]) {
      const errors = Misc.getValidationErrors(event.target.value, property, fabricatorData);
      if (!errors.length) {
        changeUserInfoErrors({
          [property]: errors
        })
      }
    }
  };

  const errorsExist = Array.isArray(userInfoErrors[property]) && userInfoErrors[property].length;

  const requiredFields = fabricatorData.isCaesarStone
    ? ["lastName", "city", "state"]
    : ["firstName", "email", "postal", "phoneNumber"];

  return (
    <div className="ass-field">
      <input type="text"
             name={property}
             className={"ui-input ui-input--new ass-field__input" + (errorsExist ? " ui-input--error" : "")}
             onChange={onChange}
             onBlur={onBlur}
             placeholder={intl.formatMessage({id: placeholder})}
             value={inputValue}
      />
      {requiredFields.includes(property) ? <span className="ass-field__required">*</span> : null}
      <UserFieldErrors property={property}/>
    </div>
  )
};

AssignQuotePopupNewCustomerInput.propTypes = {
  property: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  inputsValidated: PropTypes.bool.isRequired,
  isActive: PropTypes.bool.isRequired,
};

const mapStateToProps = (store) => {
  const {userInfo, userInfoErrors} = store.userState;
  return {
    userInfo,
    userInfoErrors,
    fabricatorData: store.fabricatorState,
    // assignQuotePopupSearchText: store.assignQuoteState.assignQuotePopupSearchText
  };
};

const mapDispatchToProps = {
  changeUserInfo,
  changeUserInfoErrors
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(AssignQuotePopupNewCustomerInput)
)
